import styles from "../Editor.module.scss";

const DelimiterBlock = () => {
    return (
        <hr className={styles.reDelimiter} />
    );
}

export default DelimiterBlock;
